import { getPreserveExpectedErrorsForCallerContext } from "../../../../utils/apolloErrorPolicy";
import { CMP_EVENT_HOSTED_CHECKOUT_ACTION_BLOCKED_CODE } from "../../Events/EventSales/eventSalesApolloErrorPolicy";

/**
 * Manage Invoices actions show every GraphQL failure in the action error
 * dialog. Without this context the global Apollo error link sends staff to
 * /error500 (Sentry 5A: a void blocked by an open hosted checkout). Expected
 * business errors are not reported to Sentry; other codes are still reported.
 */
export const manageInvoiceActionApolloContext =
  getPreserveExpectedErrorsForCallerContext({
    expectedGraphQLErrorCodes: [
      "BAD_USER_INPUT",
      CMP_EVENT_HOSTED_CHECKOUT_ACTION_BLOCKED_CODE,
    ],
  });
